<template>
  <span
    class="metatype-badge"
    :class="[`is-${slug}`, `is-${size}`, { 'is-hybrid': hybrid }]"
  >
    <MetatypeIcon :metatype="metatype" />
    <span class="metatype-badge__label">{{ metatype }}</span>
    <span v-if="hybrid && runnerUp" class="metatype-badge__second">
      &thinsp;/&thinsp;{{ runnerUp }}
    </span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import MetatypeIcon from './MetatypeIcon.vue';

const props = defineProps({
  metatype: { type: String, required: true },
  runnerUp: { type: String, default: null },
  hybrid: { type: Boolean, default: false },
  size: { type: String, default: 'md' },
});

const slug = computed(() => (props.metatype || 'unknown').toLowerCase());
</script>

<style scoped>
/* The badge carries colour on the mark and the text, not as a filled pill.
   Twenty filled pills stacked down a roster read as a bag of sweets; a stroked
   mark beside a tracked label reads as a classification. */
.metatype-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35em;
  color: var(--metatype-color, var(--gm-text-muted));
  font-family: var(--gm-font-display);
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  line-height: 1;
  white-space: nowrap;
}

.metatype-badge.is-sm { font-size: 0.56rem; }
.metatype-badge.is-md { font-size: 0.64rem; }
.metatype-badge.is-lg { font-size: 0.72rem; }

.is-attacker { --metatype-color: #d8635c; }
.is-defender { --metatype-color: var(--gm-info); }
.is-healer { --metatype-color: var(--gm-success); }
.is-buffer { --metatype-color: var(--gm-accent); }
.is-debuffer { --metatype-color: #a888c9; }

.metatype-badge__second {
  color: var(--gm-text-dim);
  font-weight: 500;
  letter-spacing: 0.06em;
}

/* A hybrid is genuinely two things, so the mark is drawn half-strength rather
   than given a badge of its own. */
.metatype-badge.is-hybrid :deep(.metatype-icon) {
  opacity: 0.65;
}
</style>
